<template>
  <div class="jin-resume-info">
    <JinPc />
    <JinM />
  </div>
</template>

<script>
import JinPc from './page/pc'
import JinM from './page/mobileInfo'
export default {
  components: {
    JinPc,
    JinM
  },
  data() {
    return {

    }
  }
}
</script>
